import { render } from "./IdentitasPerusahaan.vue?vue&type=template&id=154b8eb3&scoped=true"
import script from "./IdentitasPerusahaan.vue?vue&type=script&lang=js"
export * from "./IdentitasPerusahaan.vue?vue&type=script&lang=js"

import "./IdentitasPerusahaan.vue?vue&type=style&index=0&id=154b8eb3&scoped=true&lang=css"

import exportComponent from "/var/www/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154b8eb3"]])

export default __exports__